import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../shared/services/apiService.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-explore-vehicle-range',
  templateUrl: './explore-vehicle-range.component.html',
  styleUrls: ['./explore-vehicle-range.component.scss']
})
export class ExploreVehicleRangeComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription
  exploreVehicleRangeList: any = [];
  exploreVehicleRangeRESPList: any = [];
  newexploreVehicleRangeList: any = [];
  newexploreVehicleRangeRESPList: any = [];

  environment1 = environment.s3bucket.url;
  vehicltype: any;

  constructor(private apiService: ApiService, private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,) { }

  ngOnInit(): void {

    // this.getExploreVehicleRange('trucks');
    this.getVehicleRange('Trucks') ;
  }
  onTabClick(value: any) {
    this.exploreVehicleRangeList = [];

    for (let i = 0; i < this.exploreVehicleRangeRESPList?.length; i++) {
      for (let j = 0; j < this.exploreVehicleRangeRESPList[i].actual_lob?.length; j++) {
        if (value == 'trucks') {
          if (this.exploreVehicleRangeRESPList[i].actual_lob[j] == 'TRUCKS') {
            this.exploreVehicleRangeList.push(this.exploreVehicleRangeRESPList[i])
          }
        }
        if (value == 'buses-vans') {
          if (this.exploreVehicleRangeRESPList[i].actual_lob[j] == 'Buses') {
            this.exploreVehicleRangeList.push(this.exploreVehicleRangeRESPList[i])
          }
        }
        if (value == 'scv-pickups') {
          if (this.exploreVehicleRangeRESPList[i].actual_lob[j] == 'SCV Pickups') {
            this.exploreVehicleRangeList.push(this.exploreVehicleRangeRESPList[i])
          }
        }
      }
    }

  }

  onTabClickapi(value: any) {
    this.newexploreVehicleRangeList = [];
    this.getVehicleRange(value)

  }

  getVehicleRange(value: any) {
    try {
      this.exploreVehicleRangeList = [];
      this.newexploreVehicleRangeRESPList = [];
      const data = {
        level1: value,
        level3: "",
        search: value
      };
      this.spinner.show();

      this.sub.add(this.apiService.advanceSearch(data).subscribe({
        next: (response: any) => {
          this.spinner.show();
          if (response.success) {
            this.spinner.hide();
            this.vehicltype = value
            // Store the received response data
            const responseData = response.data.data;
            if (value === 'Trucks') {

              const sortedData = [
                {l2_actual_name: "Heavy Truck" },
                {l2_actual_name: "Tipper" },
                {l2_actual_name: "Tractor Trailer" },
                {l2_actual_name: "6 Wheeler Truck" },
                {l2_actual_name: "Distribution Truck" },
                {l2_actual_name: "Light Truck" }
              ].map(serialData => {
                return responseData.find(item => item.l2_actual_name === serialData.l2_actual_name);
              }).filter(item => item); // Remove any undefined results

              this.newexploreVehicleRangeRESPList = sortedData;

            } else if (value === 'Buses') {
              const sortedData = [
                "Staff Bus",
                "Bus Chassis",
                "Intercity Bus",
                "School Bus"
              ].map(name => {
                return responseData.find(item => item.l2_actual_name === name);
              }).filter(item => item); // Remove any undefined results

              this.newexploreVehicleRangeRESPList = sortedData;

            } else if (value === 'Vans') {
              const sortedData = [
                "Passenger Van",
                "School Van",
                "Ambulance"
              ].map(name => {
                return responseData.find(item => item.l2_actual_name === name);
              }).filter(item => item); // Remove any undefined results

              this.newexploreVehicleRangeRESPList = sortedData;

            } else if (value === 'SCV & Pickups') {
              const sortedData = [
                "Mini Truck",
                "Small Pickup",
                "Large Pickup"
              ].map(name => {
                return responseData.find(item => item.l2_actual_name === name);
              }).filter(item => item); // Remove any undefined results

              this.newexploreVehicleRangeRESPList = sortedData;
            }

          } else {
            this.exploreVehicleRangeList = [];
            this.toastrService.warning(response.data.msg);
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
        complete: () => {}
      }));
    } catch (error) {
      this.spinner.hide();
    }
  }

  explorePage(product) {
   

    let product_name = product?.replace(/\s/g, "-")?.toLowerCase();
    this.router.navigateByUrl('/category-list/' + product_name)
    if (isPlatformBrowser(this.platformId)) {
    localStorage.setItem('categoryIcons' , product_name)
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
